import { useEffect } from 'react'

import { LayerIds } from 'client/components/Map/ids'
import { PropsMapHook } from 'client/components/Map/types'

export const useUpdateCursorStyle = (props: PropsMapHook): void => {
  const { loaded, mapRef } = props

  useEffect(() => {
    if (loaded) {
      const map = mapRef.current!.getMap()

      // Pointer cursor on hover
      map.on('mouseenter', [LayerIds.clusterCount, LayerIds.unclusteredPoint], () => {
        map.getCanvas().style.cursor = 'pointer'
      })

      map.on('mouseleave', [LayerIds.clusterCount, LayerIds.unclusteredPoint], () => {
        map.getCanvas().style.cursor = ''
      })
    }
  }, [loaded, mapRef])
}
